import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@mdi/font/css/materialdesignicons.css'

import axios from 'axios'
import Toasted from 'vue-toasted'

Vue.use(Toasted)

Vue.config.productionTip = false

// setup axios
const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_HOST
})

axiosInstance.interceptors.request.use(function (config) {
  if (store.state.token) {
    config.headers.Authorization = `Bearer ${store.state.token}`
  }

  return config
}, function (error) {
  return Promise.reject(error)
})

axiosInstance.interceptors.response
  .use(response => response, error => {
    if (error.response && error.response.status === 401) {
      store.commit('LOGOUT')
      router.push('/login')
    }

    return Promise.reject(error)
  })

Vue.http = Vue.prototype.$http = axiosInstance

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  vuetify,
  render: h => h(App)
})
